<template>
  <div class="popup-full  modal-deactivate-vacancy">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pending"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="@/assets/img/reject-candidate.jpg"
                   :alt="$tMyVacancy('Deactivate vacancy')">
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tMyVacancy('Deactivate vacancy') }}</h3>

          <div class="modal-deactivate-vacancy__reject">
            <h4 class="modal-deactivate-vacancy__title">{{ $tMyVacancy('Enter a reason for deactivate') }}</h4>
            <BaseSelect
              v-model="inputs.close_reason_id.value"
              :error="inputs.close_reason_id.error"
              :options="closReasons"
              text-key="name" class="modal-deactivate-vacancy__input _white"/>

            <BaseInput :label="$tMyVacancy('Additional comment')"
                       v-model="inputs.close_reason_text.value"
                       textarea
                       rows="4"
                       class="modal-deactivate-vacancy__input  _white"/>

            <div class="modal-deactivate-vacancy__input-title">
              {{ $tMyVacancy('Found people for this vacancy?') }}
            </div>
            <BaseRadioList v-model="inputs.find_people.value"
                           :options="findPeopleOptions"
                           text-key="name"
                           class="modal-deactivate-vacancy__input  _white"/>
            <BaseInputError style="margin-top: -0.5rem"
                            :value="inputs.find_people.error"/>
          </div>

          <BaseAlert :value="overallErrorsMix"
                     class="popup-full__error  _warning"/>

          <div class="popup-full__buttons">
            <button @click="onDeactivateVacancy"
                    type="button"
                    class="popup-full__btn  base-btn base-btn--red">
              <span>{{ $tMyVacancy('Deactivate') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formMixins from '@/mixins/formMixins'
  import BaseInputError from '@/components/BaseInputError'

  export default {
    name: 'ModalDeactivateVacancy',
    components: {BaseInputError},
    mixins: [formMixins],
    props: {
      vacancyId: Number,
      callBack: Function,
    },
    data() {
      return {
        pending: false,
        inputs: {
          close_reason_id: {
            value: null,
            required: true
          },
          close_reason_text: {
            value: null
          },
          find_people: {
            value: null
          }
        },
        closReasons: []
      }
    },
    computed: {
      findPeopleOptions() {
        return [{
          id: 1,
          name: this.$tMyVacancy('Yes, I found people')
        }, {
          id: 0,
          name: this.$tMyVacancy('No, I not found people')
        }]
      }
    },
    methods: {
      close() {
        this.$vModal.close('deactivate-vacancy')
      },
      onDeactivateVacancy() {
        this.resetErrorsMix(this.inputs)
        const params = this.createSendDataMix(this.inputs)
        if (this.isRequiredEmptyMix) return

        this.pending = true;

        debugger

        return http.post(`/api/cabinet/vacancy/${this.vacancyId}/set-inactive`,
          params
        )
          .then(() => {
            if (typeof this.callBack === 'function') {
              this.callBack()
            }

            this.close()
          }).catch(e => {
            this.errorHandlerMix(e)
          }).finally(() => {
            this.pending = false;
          });
      },
      loadReasons() {
        this.pending = true

        return http.get(`/api/helper/selectbox/vacancy_close_reason`).then(({data}) => {
          this.closReasons = data.data
        }).catch(e => {
          this.errorHandlerMix(e)
        }).finally(() => {
          this.pending = false;
        });
      },
    },
    created() {
      this.loadReasons()
    }
  }
</script>

<style lang="less">

</style>
